import type { FormVariant } from "./types";

import { identifyAnonymous, track } from "./analytics";

const LeadEvents = {
  LEAD_CREATED: "sf-lead-created",
};

const commonParams = () => {
  return {
    page_path: window.location.pathname,
    page_url: window.location.href,
  };
};

type LeadEventParams = {
  formVariant: FormVariant;
} & Partial<{
  leadId: string;
  organizationNumber: number;
  // TODO: Update types on selectedOptions and recipient to align with types from the form
  selectedOptions: string[];
  recipient: string;
}>;

const commonLeadParams = ({
  leadId,
  organizationNumber,
  selectedOptions,
  recipient,
  formVariant,
}: LeadEventParams) => {
  return {
    form_variant: formVariant,
    franchise_number: organizationNumber,
    lead_id: leadId,
    recipient,
    selected_options: selectedOptions,
  };
};

// lead was created (client-side tracking - should also happen in the API)
const trackLeadCreated = (leadParams: LeadEventParams) => {
  track(LeadEvents.LEAD_CREATED, {
    element_name: "schedule-call",
    event: LeadEvents.LEAD_CREATED,
    ...commonParams(),
    ...commonLeadParams(leadParams),
  });
};

const identifyLead = async (leadIdentityParams: {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
}) => identifyAnonymous(leadIdentityParams);

export { identifyLead, trackLeadCreated };
